$(function() {

    const navToggle = $("#navToggle");
    const nav = $("#categoriesSidebar");

    navToggle.on("click", () => {
        if( !nav.hasClass('opened') ) {
            nav.addClass("opened");
            $("body").addClass("no-scroll");
        } else {
            closeSidebar();
        }
    })


    $("#categoriesSidebar, #navToggle, #nav, [data-show='.sidebar__form']").on("click", (event) => {
        event.stopPropagation();
    });


    $("body").on("click", function(event) {
        closeSidebar();
    });


    $("[data-close-categories]").on("click", () => {
        closeSidebar();
    });


    function closeSidebar() {
        nav.removeClass("opened");
        $("body").removeClass("no-scroll");
    }

})